import {
  CLEAR_ASSETS,
  LOAD_ASSETS,
  LOAD_ASSETS_FAILURE,
  LOAD_ASSETS_SUCCESS,
} from '../actions'
import { AssetLoadState } from '../types'
import { AlpsAssetWithMarginCode } from '../types/Asset'

const INITIAL_STATE: AssetLoadState = {
  assets: [],
  loadingAssets: false,
}

export const assetsReducer = (
  state: AssetLoadState = INITIAL_STATE,
  {
    type,
    assets = [],
  }: { type: string; assets?: AlpsAssetWithMarginCode[]; errorMessage?: string }
): AssetLoadState => {
  switch (type) {
    case LOAD_ASSETS:
      return { ...INITIAL_STATE, loadingAssets: true }
    case LOAD_ASSETS_SUCCESS:
      return { ...state, loadingAssets: false, assets }
    case LOAD_ASSETS_FAILURE:
      return { ...state, loadingAssets: false }
    case CLEAR_ASSETS:
      return INITIAL_STATE
    default:
      return state
  }
}
